import { Spacer } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import AccordionHeader from './AccordionHeader';
import AccordionToggle from './AccordionToggle';
import { block } from './utils';

type AccordionProps = {
  isExpanded: boolean;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
  onToggle: () => void;
};

const Accordion: React.FC<AccordionProps> = ({
  isExpanded,
  title,
  description,
  className,
  children,
  onToggle,
}) => {
  return (
    <div
      className={cn(block({ expanded: isExpanded }), className)}
      role="button"
      tabIndex={0}
      aria-expanded={isExpanded}
      onClick={onToggle}
      onKeyDown={onToggle}
    >
      <Spacer
        space="4px"
        orientation="vertical"
        align="flex-start"
        justify="center"
        className={block('contents')}
      >
        <AccordionHeader {...{ title, description, isExpanded }} />

        <div className={block('contents-inner')}>{children}</div>
      </Spacer>

      <AccordionToggle onToggle={onToggle} />
    </div>
  );
};

export default Accordion;
